<template>
  <div :style="!standalone ? 'margin:20px' : 'margin:5px'">
    <div v-if="!standalone" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Status Manager</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        latest status for all vehicles, statuses can be manually updated using the dropdowns, notes can be added and will auto save, click + to show more details & status history
        <span style="float:right; font-weight: bold; font-size: 18px;"><b-button variant="success" size="sm" @click="view_more_info = !view_more_info"><b>more info</b></b-button></span>
      </div>
    </div>
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;Vehicle Status Manager&nbsp;
      <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
      </span>
    </div>

    <div v-if="!loading && !mobile_view">
      <div class="row" style="margin: 20px 0px 25px 0px; font-weight: bold; font-size: 20px;">
        <div @click="filter_by_status(null)" class="col total" :style="selected_vehicle_status==null ? 'border: 2px solid red;' : 'border: 2px solid grey;'">{{items.length}} of {{summary.total_cnt}}</div>
        <div style="margin:8px 5px 0px 5px">|</div>
        <div @click="filter_by_status('available')" :style="selected_vehicle_status=='available' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col available">Available-{{available_cnt}}</div>
        <div style="margin:8px 5px 0px 5px">|</div>
        <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
        <div @click="filter_by_status('cleaned')" :style="selected_vehicle_status=='cleaned' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_status=='washed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
        <div @click="filter_by_status('dirty')" :style="selected_vehicle_status=='dirty' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
        <div @click="filter_by_status('out')" :style="selected_vehicle_status=='out' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
        <div style="margin:8px 5px 0px 5px">|</div>
        <div @click="filter_by_maint_status('ready')" :style="selected_maintenance_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready" >Ready-{{maint_ready_cnt}}</div>
        <div @click="filter_by_maint_status('pending_dvir')" :style="selected_maintenance_status=='pending_dvir' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col pending_dvir" >Pending-{{pending_dvir_cnt}}</div>
        <div @click="filter_by_maint_status('unsafe_dvir')" :style="selected_maintenance_status=='unsafe_dvir' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col unsafe_dvir" >Unsafe-{{unsafe_dvir_cnt}}</div>
        <div @click="filter_by_maint_status('pm')" :style="selected_maintenance_status=='pm' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col pm" >PM-{{pm_cnt}}</div>
        <div @click="filter_by_maint_status('oos')" :style="selected_maintenance_status=='oos' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos" >OOS-{{oos_cnt}}</div>
        <div v-if="base_options && base_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold; width:180px"/></div>
        <div v-if="vehicle_tag_options && vehicle_tag_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_vehicle_tag" :options="vehicle_tag_options" style="font-size: 18px; font-weight: bold;"/></div>
        <div class="d-flex align-items-center justify-content-center">
          &nbsp;<b-btn size="sm" @click="load_data()"><span style="font-size: 18px; font-weight: bold">Reload</span></b-btn>
          &nbsp;<span @click="printPage()"><img height="30px" src="/print-icon.png"/></span>
        </div>
      </div>
    </div>
    <div v-if="!loading && mobile_view">
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div class="col" @click="filter_by_status(null)" style="border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px">{{items.length}}/{{summary.total_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 16px;">
        <div class="col ready" v-if="washed_enabled" @click="filter_by_status('ready')">Ready-{{ready_cnt}}</div>
        <div class="col out" @click="filter_by_status('out')">Out-{{out_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 16px;">
        <div class="col cleaned"  @click="filter_by_status('cleaned')">Clean-{{clean_cnt}}</div>
        <div class="col washed"  v-if="washed_enabled" @click="filter_by_status('washed')">Washed-{{washed_cnt}}</div>
        <div class="col dirty"  @click="filter_by_status('dirty')">Dirty-{{dirty_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 16px;">
        <div class="col pending_dvir" @click="filter_by_maint_status('pending_dvir')">Pending-{{pending_dvir_cnt}}</div>
        <div class="col unsafe_dvir"  @click="filter_by_maint_status('unsafe_dvir')">Unsafe-{{unsafe_dvir_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 16px;">
        <div class="col pm" @click="filter_by_maint_status('pm')">PM-{{pm_cnt}}</div>
        <div class="col oos" @click="filter_by_maint_status('oos')">OOS-{{oos_cnt}}</div>
      </div>
      <div class="col d-flex align-items-center justify-content-center" style="border: none; margin-bottom: 5px"><b-form-input style="font-size: 16px; font-weight: bold;" v-model="search_filter" placeholder="filter by keyword"/></div>
    </div>

    <b-modal title="More Info" size="xl" v-model="view_more_info" ok-only>
      <h4>Here are details on the statuses and filters used for the VSM</h4>
      <br/>
      <h4>Special Filters</h4>
      <span v-if="washed_enabled">
        &nbsp;&nbsp;AVAILABLE - vehicles in READY vehicle status and READY maintenance status
      </span>
      <span v-else>
        &nbsp;&nbsp;AVAILABLE - vehicles in CLEAN vehicle status and READY maintenance status
      </span>
      <br><hr/>
      <h4>Vehicle Status</h4>
      <span v-if="washed_enabled">
        &nbsp;&nbsp;CLEANED - indicates that the vehicle interior has been cleaned (manually managed)
        <br/>&nbsp;&nbsp;WASHED - indicates that the vehicle exterior has been washed (manually managed)
        <br/>&nbsp;&nbsp;READY - automatically set by the system when a vehicle has been cleaned and washed and is ready for service
      </span>
      <span v-else>
        &nbsp;&nbsp;CLEAN - indicates that the vehicle is clean & ready for service (manually managed)
      </span>
      <br/>&nbsp;&nbsp;DIRTY - automatically set by the system when a vehicle arrives back to the finish location or yard
      <br/>&nbsp;&nbsp;OUT - automatically set by the system when a vehicle leaves for a planned booking
      <br><hr/>
      <h4>Maintenance Status</h4>
      &nbsp;&nbsp;READY - automatically set by the system when DVIRs are clear unless manually set to PM or OOS status
      <br/>&nbsp;&nbsp;PENDING_DVIR - automatically set by the system if pending DVIRs exist
      <br/>&nbsp;&nbsp;UNSAFE_DVIR - automatically set by the system if unsafe DVIRs exist
      <br/>&nbsp;&nbsp;PM - planned / preventative maintenance (manually managed)
      <br/>&nbsp;&nbsp;OOS - out of service (manually managed)
      <br><hr/>
      <h4>VSM Standalone Mode</h4>
      &nbsp;&nbsp;provides a readonly view that refreshes every minute to keep all teams in sync
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-fasttrak/reload/' + this.tenant_id">click here to load the standalone Dispatch VSM (by depart time)</a>
      <span v-if="base_options && base_options.length > 2">
        <br/><br/>&nbsp;&nbsp;Click on a base name to load the VSM specific to that base.<br/>
        <span v-if="base.value != ''" v-for="base in base_options">
          &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-fasttrak/reload/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
        </span>
      </span>
      <br><hr/>
      <span v-if="summary.aws_phone_number">
        <h4>Update Status & Notes Over SMS</h4>
        &nbsp;&nbsp;simply send a text in one of the following formats: to #{{summary.aws_phone_number | prettyPhoneNumber}}<br>
        &nbsp;&nbsp;&nbsp;&nbsp;update the status only, send '[status] [vehicle name]' - for example 'cleaned 123'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the notes only, send 'notes [vehicle name], [notes]' - for example 'notes 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;update the status & notes, send '[status] [vehicle name], [notes]' - for example 'cleaned 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to clear notes, send '[notes] [vehicle name]' - for example 'notes 123'
      </span>
    </b-modal>

    <b-table :busy="loading" sticky-header="100vh" responsive :style="'font-size:' + summary.font_size + 'px'" bordered :items="items" :fields="visibleFields" small
             :current-page="currentPage" :tbody-tr-class="get_row_color" :sort-compare="tableSortCompare"
             :per-page="perPage">

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template slot="vehicle_status" slot-scope="row">
        <b-form-select v-if="!standalone && !(user.role=='dispatch' || user.role=='garage')" v-model="row.item.vehicle_status" :options="status_options" @change="update_vehicle_status(row, row.item)"/>
        <span v-else>{{row.item.vehicle_status}}</span>
      </template>

      <template slot="maintenance_status" slot-scope="row">
        <b-form-select v-if="!standalone  && !(user.role=='dispatch' || user.role=='wash-bay')" v-model="row.item.maintenance_status" :options="maintenance_status_options" @change="update_maint_status(row, row.item)"/>
        <span v-else>{{row.item.maintenance_status}}</span>
      </template>

      <template slot="notes" slot-scope="row">
        <div v-if="!standalone" class="d-flex align-items-center justify-content-center">
            <b-form-input :style="'font-size:' + summary.font_size + 'px; min-width:300px'" v-model="row.item.notes" :disabled="updating" v-on:blur="update_notes(row, row.item)"/>
        </div>
        <div style="text-align: left" v-else>{{row.item.notes}}</div>
      </template>

      <template slot="next_mvmt_id" slot-scope="row">
        <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + row.item.next_mvmt_booking_hash }">{{ row.item.next_mvmt_id }}</router-link>
      </template>

      <template slot="current_mvmt_return_time" slot-scope="row">
        {{row.item.current_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
      </template>
      
      <template slot="current_mvmt_id" slot-scope="row">
        <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + row.item.current_mvmt_booking_hash }">{{ row.item.current_mvmt_id }}</router-link>
      </template>

      <template slot="last_gps_time" slot-scope="row">
        {{row.item.last_gps_time | formatDateTimeCustom(summary.datetime_format)}}
      </template>

      <template slot="next_mvmt_driver" slot-scope="row">
        <template v-if="row.item.next_mvmt_driver" v-for="driver,idx in row.item.next_mvmt_driver">
          <span v-if="idx>0"><br/></span>
          {{driver | trim(20)}}
        </template>
      </template>

      <template slot="name" slot-scope="row">
        <a target="_blank" :href="'/#/vehicle-track/' + tenant_id + '/' + row.item.name">{{row.item.name}}</a>
      </template>

      <template slot="processed_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_dirty_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_washed_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_returned_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="next_mvmt_driver" slot-scope="row">
        <template v-if="row.item.next_mvmt_driver" v-for="driver,idx in row.item.next_mvmt_driver">
          <span v-if="idx>0"><br/></span>
          {{driver | trim(20)}}
        </template>
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_driver | trim(20)}}
        </template>
      </template>

      <template slot="next_mvmt_time" slot-scope="row">
        {{row.item.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>
      </template>

      <template slot="next_mvmt_id" slot-scope="row">
        {{row.item.next_mvmt_id}}
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_id}}
        </template>
      </template>

      <template slot="next_mvmt_start_finish_base" slot-scope="row">
        {{row.item.next_mvmt_start_base | trim(15)}} / {{row.item.next_mvmt_finish_base | trim(15)}}
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_start_base | trim(15)}} / {{next_mvmt.next_mvmt_finish_base | trim(15)}}
        </template>
      </template>

      <template slot="next_mvmt_start_base" slot-scope="row">
        {{row.item.next_mvmt_start_base | trim(15)}}&nbsp;
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_start_base | trim(15)}}&nbsp;
        </template>
      </template>

      <template slot="next_mvmt_finish_base" slot-scope="row">
        {{row.item.next_mvmt_finish_base | trim(15)}}&nbsp;
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_finish_base | trim(15)}}&nbsp;
        </template>
      </template>

      <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: red'">
            {{row.item.next_mvmt_delta}}
          </span>
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_delta}}
        </template>
      </template>

      <template slot="next_mvmt_return_time" slot-scope="row">
        {{row.item.next_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
        <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
          <br/>{{next_mvmt.next_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>
      </template>

      <template slot="current_mvmt_return_delta" slot-scope="row">
        <span v-if="row.item.current_mvmt_return_delta" :style="row.item.current_mvmt_return_delta.indexOf('d') != -1 ? '' : 'color: green'">
          {{row.item.current_mvmt_return_delta}}
        </span>
      </template>

      <template slot="current_mvmt_delta" slot-scope="row">
        <span v-if="row.item.current_mvmt_delta" :style="row.item.current_mvmt_delta.indexOf('late') == -1 ? '' : 'color: red'">
          {{row.item.current_mvmt_delta}}
        </span>
      </template>

      <template slot="last_cleaned_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_out_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_maintenance_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_maintenance_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="last_ready_time" slot-scope="row">
        <span v-if="row.item.vehicle_info">
          {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
        </span>
      </template>

      <template slot="details" slot-scope="row">
        <b-button v-if="!(user.role == 'garage' || user.role == 'wash-bay')" size="sm" @click="get_vehicle_info_history(row.item); row.toggleDetails();">
          {{ row.detailsShowing ? '-' : '+' }}
        </b-button>&nbsp;
      </template>

      <template slot="row-details" slot-scope="row">
        <b-card style="text-align: left;">
            <b>Status Change History</b>
            <b-table bordered :items="row.item.history" :fields="visibleHistoryFields" :tbody-tr-class="get_history_row_color">
              <template slot="processed_time" slot-scope="row">
                {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_maintenance_time" slot-scope="row">
                {{row.item.last_maintenance_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_dirty_time" slot-scope="row">
                  {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_cleaned_time" slot-scope="row">
                {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_out_time" slot-scope="row">
                {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_returned_time" slot-scope="row">
                {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_ready_time" slot-scope="row">
                {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="notes" slot-scope="row">
                <div style="margin:3px; text-align: left">{{row.item.notes}}</div>
              </template>
              <template slot="wheelchair" slot-scope="row">
                <b-checkbox size="lg" v-model="row.item.wheelchair" disabled/>
              </template>
              <template slot="tote" slot-scope="row">
                <b-checkbox size="lg" v-model="row.item.tote" disabled/>
              </template>
            </b-table>
        </b-card>
      </template>
    </b-table>
    <b-row v-if="!standalone">
      <b-col>
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center"
        >
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {get_vehicle_info_history, get_vehicle_info, update_vehicle_status, get_vehicle_info_fasttrak} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'

export default {
  name: 'vehicle_status_dvir_fasttrak',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      view_more_info: false,
      standalone: false,
      return_mode: false,
      mobile_view: false,
      tenant_id: null,
      updating: false,
      items_filter: null,
      columnSelection: false,
      reloading: false,
      reload_mode: 0,
      timer: null,
      items: [],
      items_full: [],
      summary: [],
      selected_base: '',
      selected_vehicle_tag: '',
      vehicle_tag_options: [],
      base_options: [],
      loading: true,
      washed_enabled: false,
      selected_vehicle_status: null,
      selected_maintenance_status: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      status_options: [
        { value: 'READY', text: 'READY' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'CLEANED', text: 'CLEAN' },
        { value: 'WASHED', text: 'WASHED' },
        { value: 'OUT', text: 'OUT' },
      ],
      maintenance_status_options: [
        { value: 'READY', text: 'READY' },
        { value: 'PENDING_DVIR', text: 'PENDING' },
        { value: 'UNSAFE_DVIR', text: 'UNSAFE' },
        { value: 'PM', text: 'PM' },
        { value: 'OOS', text: 'OOS' },
      ],
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "30px" }},
        { key: 'name', label: 'ID', sortable: true, stickyColumn: true, thStyle: { width: "100px" }, isRowHeader: false},
        { key: 'vehicle_status', label:'Status', sortable: true, thStyle: { width: "130px" }},
        { key: 'maintenance_status', label:'Maint Status', sortable: true, thStyle: { width: "130px" }},
        { key: 'current_mvmt_return_time', label: 'Return', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'current_mvmt_return_delta', label: 'Returns In', sortable: true, visible: true, thStyle: { width: "140px" }},

        { key: 'last_cleaned_time', label:'Cleaned', sortable: true, visible: false, thStyle: { width: "140px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: false},
        { key: 'last_washed_time', label:'Washed', sortable: true, visible: false, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: false},
        { key: 'last_ready_time', label:'Ready', sortable: true, visible: false, thStyle: { width: "140px" }},

        { key: 'last_returned_time', label:'Last Return', sortable: true, thStyle: { width: "140px" }},

        { key: 'next_mvmt_start_finish_base', label: 'Next Start / Finish', sortable: true, visible: true, thStyle: { width: "230px" }},
        { key: 'next_mvmt_start_base', label: 'Next Start', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_finish_base', label: 'Next Finish', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_return_time', label:'Next Return', sortable: true, thStyle: { width: "140px" }},
        { key: 'next_mvmt_driver', label:'Driver', sortable: true, thStyle: { width: "175px" }},
        { key: 'next_mvmt_id', label:'Next ID', sortable: true, thStyle: { width: "100px" }},
        { key: 'next_mvmt_time', label:'Next Depart', sortable: true, thStyle: { width: "160px" }},
        { key: 'next_mvmt_delta', label:'Departs In', sortable: true, thStyle: { width: "160px" }},

        { key: 'notes', label: 'Notes', sortable: true, thStyle: { width: "300px" }},
      ],
      history_fields: [
        { key: 'processed_time', label:'Last Updated', sortable: true},
        { key: 'updated_by', label:'Updated By', sortable: true},
        { key: 'vehicle_status', label:'Status', sortable: true},
        { key: 'maintenance_status', label:'Maint Status', sortable: true},
        { key: 'last_cleaned_time', label:'Cleaned', sortable: true, visible: false, thStyle: { width: "140px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: false},
        { key: 'last_washed_time', label:'Washed', sortable: true, visible: false, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: false},
        { key: 'last_ready_time', label:'Ready', sortable: true, visible: false, thStyle: { width: "140px" }},
        { key: 'last_maintenance_time', label:'Last Maint Time', sortable: true},
        { key: 'last_cleaned_time', label:'Cleaned Time', sortable: true},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true},
        { key: 'last_returned_time', label:'Returned Time', sortable: true},
        { key: 'notes', label: 'Notes', sortable: true},
      ]
    }
  },
  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  mounted() {
    this.stopTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    printPage() {
      window.print();
    },
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0) {
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.mobile_view = true;
        return true
      } else {
        return false
      }
    },
    isTablet() {
      if(/iPad/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    tableSortCompare(itemA, itemB, key) {
      if (key !== 'next_mvmt_delta') {
        return false
      } else {
        return itemA['next_mvmt_ms'] - itemB['next_mvmt_ms']
      }
    },
    async check_features() {

      if (this.$route.path.indexOf('/vsm-fasttrak/') == -1) {
        this.standalone = false
        this.return_mode = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/vsm-fasttrak/reload/') != -1) {
        this.standalone = true

        let filter = this.$route.path.split('/vsm-fasttrak/reload/')[1]

        if (filter.indexOf('/tag') != -1) {
          this.tenant_id = filter.split("/tag/")[0];
          this.selected_vehicle_tag = filter.split("/tag/")[1];
        } else if (filter.indexOf('/') != -1) {
          this.tenant_id = filter.split("/")[0];
          this.selected_base = filter.split("/")[1];
        } else {
          this.tenant_id = filter;
        }

        this.return_mode = false
        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-fasttrak/reloadreturn/') != -1) {
        this.standalone = true
        this.return_mode = true
        let filter = this.$route.path.split('/vsm/reloadreturn/')[1]

        if (filter.indexOf('/tag') != -1) {
          this.tenant_id = filter.split("/tag/")[0];
          this.selected_vehicle_tag = filter.split("/tag/")[1];
        } else if (filter.indexOf('/') != -1) {
          this.tenant_id = filter.split("/")[0];
          this.selected_base = filter.split("/")[1];
        } else {
          this.tenant_id = filter;
        }

        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-fasttrak/') != -1) {
        this.standalone = true
        this.return_mode = false
        this.tenant_id = this.$route.path.split('/vsm-fasttrak/')[1]
      }

      this.fields = this.fields_all
      if (this.standalone)
        this.fields = this.fields.filter(item => (item.key != 'details' && item.key != 'processed_time' && item.key != 'last_out_time' && item.key != 'last_dirty_time' && item.key != 'last_cleaned_time' && item.key != 'last_cleaned_number'))

      if (this.user.role != 'admin')
        this.fields = this.fields.filter(item => (item.key.indexOf('current') == -1))

      if (this.isMobile())
        this.fields = this.fields.filter(item => (item.key == 'name' || item.key == 'vehicle_status' || item.key == 'next_mvmt_delta'))

      if (this.isTablet())
        this.fields = this.fields.filter(item => (item.key != 'current_mvmt_return_time' && item.key != 'last_ready_time' && item.key != 'next_mvmt_start_base' && item.key != 'next_mvmt_id'))

      this.load_data()
    },
    async update_maint_status(row, item) {
      this.updating = true
      try {
        let json = {
          'name': item.name,
          'maintenance_status': item.maintenance_status,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)
        if (row.detailsShowing)
          row.toggleDetails();
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_vehicle_status(row, item) {
      this.updating = true
      try {
        let json = {
          'name': item.name,
          'vehicle_status':  item.vehicle_status,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.vehicle_status)
          item.vehicle_status = data.vehicle_status

        if (row.detailsShowing)
          row.toggleDetails();
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_notes(row, item) {
      this.updating = true
      try {
        let json = {
          'name': item.name,
          'notes': item.notes,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)
        if (row.detailsShowing)
          row.toggleDetails();
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async get_vehicle_info_history(selected_item) {
      const {value: { data = [] } } = await get_vehicle_info_history(this.tenant_id, selected_item.name)
      var history_item = this.items_full.filter(item => item.name == selected_item.name)[0]
      history_item.history = data
      this.$forceUpdate()
    },
    async load_data() {
      this.loading = true
      try {
        let results = await get_vehicle_info_fasttrak(this.tenant_id,this.selected_base,this.selected_vehicle_tag,this.return_mode)

        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.bases
        this.vehicle_tag_options = data.summary.vehicle_tags

        this.washed_enabled = this.summary.washed_enabled
        if (!this.washed_enabled)
          this.status_options = this.status_options.filter(item => (item.value != 'READY' && item.value != 'WASHED'))

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return;

        if (this.reloading)
          return;

        this.reloading = true

        var results = await get_vehicle_info_fasttrak(this.tenant_id,this.selected_base,this.selected_vehicle_tag,this.return_mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        this.base_options = data.summary.bases
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    filter_by_status(status) {
      this.selected_maintenance_status = null
      if (status == null || this.selected_vehicle_status == status) {
        this.selected_vehicle_status = null
        this.items = this.items_full
      } else {
        this.selected_vehicle_status = status
        if (this.selected_vehicle_status == 'available')
          this.items = this.items_full.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY'))
        else
          this.items = this.items_full.filter(item => item.vehicle_status == status.toUpperCase())
      }
    },
    filter_by_maint_status(status) {
      this.selected_vehicle_status = null

      if (status == null || this.selected_maintenance_status == status) {
        this.selected_maintenance_status = null
        this.items = this.items_full
      } else {
        this.selected_maintenance_status = status
        if (this.selected_maintenance_status == 'garage')
          this.items = this.items_full.filter(item => (item.maintenance_status != 'READY'))
        else
          this.items = this.items_full.filter(item => item.maintenance_status == status.toUpperCase())
      }
    },
    filter_items() {
      this.items = this.items_full
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.vehicle_status, this.search_filter) || this.contains(item.start_bases, this.search_filter) || this.contains(item.next_mvmt_driver, this.search_filter) || this.contains(item.name, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
      if (this.selected_vehicle_tag) {
        this.items = this.items.filter(item => this.contains(item.vehicle_tags,this.selected_vehicle_tag))
      }
    },
    contains(val1, val2) {
      if (val1 != null && val2 != null) {
        return String(val1).toLowerCase().indexOf(String(val2).toLowerCase()) != -1;
      }
      return false;
    },
    get_row_color(item, type) {
      if (item) {
        if (item.vehicle_status && item.maintenance_status)
          return item.vehicle_status.toLowerCase() + "-" + item.maintenance_status.toLowerCase()
        else if (item.vehicle_status)
          return item.vehicle_status.toLowerCase()
        else if (item.maintenance_status)
          return item.maintenance_status.toLowerCase()
        else
          "unknown"
      }
    },
    get_history_row_color(item, type) {
      return "hist-unknown"
    },

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.isMobile() && this.summary.visible_mobile_fields)
        custom_fields = this.summary.visible_mobile_fields;
      else if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },
    visibleHistoryFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_history_fields)
        custom_fields = this.summary.visible_history_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.history_fields.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.history_fields
    },
    available_cnt() {
      if (this.washed_enabled)
        return this.items_full.filter(item => (item.vehicle_status == 'READY' && item.maintenance_status == 'READY')).length
      else
        return this.items_full.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY')).length
    },
    ready_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'READY').length
    },
    clean_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'CLEANED').length
    },
    washed_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'WASHED').length
    },
    dirty_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'DIRTY').length
    },
    out_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'OUT').length
    },
    maint_ready_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'READY').length
    },
    pending_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PENDING_DVIR').length
    },
    unsafe_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'UNSAFE_DVIR').length
    },
    oos_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'OOS').length
    },
    pm_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PM').length
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.tenant_id = this.user.tenant
        this.load_data()
      }
    },
    items_filter() {
      this.filter_items()
    },
    selected_base(val) {
      this.load_data()
    },
    selected_vehicle_tag(val) {
      this.filter_items()
    },
    search_filter(val) {
      this.filter_items()
    },
    reload_mode(val) {
      this.stopTimer()
      if (val > 0)
        this.startTimer()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>

<style>
.total { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.ready { background-color: hsla(120,100%,75%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.washed { background-color: hsla(160,30%,40%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

.dirty { background-color: hsla(25,28%,23%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px }
.cleaned { background-color: hsla(190,70%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.available { background-color: hsla(120,100%,75%,0.3); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.garage { background-color: white; border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.out { background-color: hsla(290,60%,70%,0.3); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.oos { background-color: hsla(357,78%,65%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.pm { background-color: hsla(210,100%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.ready { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.pending_dvir { background-color: hsla(60,100%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.unsafe_dvir { background-color: hsla(32,82%,56%,0.6); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

.unknown td { background-color: white !important; border: 1px solid black !important;}

.ready td { background-color: hsla(120,100%,75%,0.3); border: 1px solid black !important;}
.ready-ready td { background-image: linear-gradient(180deg, hsla(120,100%,75%,0.3) 80%, hsla(120,100%,75%,0.3) 20%);; border: 1px solid black !important;}
.ready-oos td { background-image: linear-gradient(180deg, hsla(120,100%,75%,0.3) 80%, hsla(357,78%,65%,0.4) 20%);; border: 1px solid black !important; }
.ready-pending_dvir td { background-image: linear-gradient(180deg, hsla(120,100%,75%,0.3) 80%, hsla(60,100%,50%,0.4) 20%); border: 1px solid black !important; }
.ready-unsafe_dvir td { background-image: linear-gradient(180deg, hsla(120,100%,75%,0.3) 80%, hsla(32,82%,56%,0.6) 20%); border: 1px solid black !important; }
.ready-pm td { background-image: linear-gradient(180deg, hsla(120,100%,75%,0.3) 80%, hsla(210,100%,50%,0.4) 20%); border: 1px solid black !important;; }

.cleaned td { background-color: hsla(190,70%,50%,0.4); border: 1px solid black !important;}
.cleaned-ready td { background-image: linear-gradient(180deg, hsla(190,70%,50%,0.4) 80%, hsla(120,100%,75%,0.3) 20%); border: 1px solid black !important; }
.cleaned-oos td { background-image: linear-gradient(180deg, hsla(190,70%,50%,0.4) 80%, hsla(357,78%,65%,0.4) 20%);; border: 1px solid black !important; }
.cleaned-pending_dvir td { background-image: linear-gradient(180deg, hsla(190,70%,50%,0.4) 80%, hsla(60,100%,50%,0.4) 20%); border: 1px solid black !important; }
.cleaned-unsafe_dvir td { background-image: linear-gradient(180deg, hsla(190,70%,50%,0.4) 80%, hsla(32,82%,56%,0.6) 20%); border: 1px solid black !important; }
.cleaned-pm td { background-image: linear-gradient(180deg, hsla(190,70%,50%,0.4) 80%, hsla(210,100%,50%,0.4) 20%); border: 1px solid black !important;; }

.washed td { background-color: hsla(160,30%,40%,0.4); border: 1px solid black !important;}
.washed-ready td { background-image: linear-gradient(180deg, hsla(160,30%,40%,0.4) 80%, hsla(120,100%,75%,0.3) 20%); border: 1px solid black !important; }
.washed-oos td { background-image: linear-gradient(180deg, hsla(160,30%,40%,0.4) 80%, hsla(357,78%,65%,0.4) 20%);; border: 1px solid black !important; }
.washed-pending_dvir td { background-image: linear-gradient(180deg, hsla(160,30%,40%,0.4) 80%, hsla(60,100%,50%,0.4) 20%); border: 1px solid black !important; }
.washed-unsafe_dvir td { background-image: linear-gradient(180deg, hsla(160,30%,40%,0.4) 80%, hsla(32,82%,56%,0.6) 20%); border: 1px solid black !important; }
.washed-pm td { background-image: linear-gradient(180deg, hsla(160,30%,40%,0.4) 80%, hsla(210,100%,50%,0.4) 20%); border: 1px solid black !important;; }

.dirty td { background-color: hsla(25,28%,23%,0.4); border: 1px solid black !important;}
.dirty-ready td { background-image: linear-gradient(180deg, hsla(25,28%,23%,0.4) 80%, hsla(120,100%,75%,0.3) 20%); border: 1px solid black !important; }
.dirty-oos td { background-image: linear-gradient(180deg, hsla(25,28%,23%,0.4) 80%, hsla(357,78%,65%,0.4) 20%); border: 1px solid black !important; }
.dirty-pending_dvir td { background-image: linear-gradient(180deg, hsla(25,28%,23%,0.4) 80%, hsla(60,100%,50%,0.4) 20%); border: 1px solid black !important; }
.dirty-unsafe_dvir td { background-image: linear-gradient(180deg, hsla(25,28%,23%,0.4) 80%, hsla(32,82%,56%,0.6) 20%); border: 1px solid black !important; }
.dirty-pm td { background-image: linear-gradient(180deg, hsla(25,28%,23%,0.4) 80%, hsla(210,100%,50%,0.4) 20%); border: 1px solid black !important; }

.out td { background-color: hsla(290,60%,70%,0.3); border: 1px solid black !important; }
.out-ready td { background-image: linear-gradient(180deg, hsla(290,60%,70%,0.3) 80%, hsla(120,100%,75%,0.4) 20%); border: 1px solid black !important; }
.out-oos td { background-image: linear-gradient(180deg, hsla(290,60%,70%,0.3) 80%, hsla(357,78%,65%,0.4) 20%); border: 1px solid black !important; }
.out-pending_dvir td { background-image: linear-gradient(180deg,hsla(290,60%,70%,0.3) 80%, hsla(60,100%,50%,0.4) 20%); border: 1px solid black !important; }
.out-unsafe_dvir td { background-image: linear-gradient(180deg,hsla(290,60%,70%,0.3) 80%, hsla(32,82%,56%,0.6) 20%); border: 1px solid black !important; }
.out-pm td { background-image: linear-gradient(180deg,hsla(290,60%,70%,0.3) 80%, hsla(210,100%,50%,0.4) 20%); border: 1px solid black !important; }

.oos td { background-color: hsla(357,78%,65%,0.4); border: 1px solid black !important; }
.pm td { background-color: hsla(210,100%,50%,0.4); border: 1px solid black !important; }
.pending_dvir td { background-color: hsla(60,100%,50%,0.4); border: 1px solid black !important; }
.unsafe_dvir td { background-color: hsla(32,82%,56%,0.6); border: 1px solid black !important; }

.hist-unknown td { background-color: white !important; background-image: none; border: 1px solid black !important;}

.table td {
  vertical-align: middle !important;
  text-align: center !important;
}

/*.b-table-sticky-header {*/
/*  overflow-y: unset !important;*/
/*}*/

tr:nth-child(even) {
  background-color: white !important;
}
tr:nth-child(odd) {
  background-color: white !important;
}

.table tr {
  padding: .1rem !important;
  vertical-align: middle !important;
  text-align: center !important;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
}

/*.b-table-sticky-header > .table.b-table > thead > tr > th {*/
/*  position: sticky !important;*/
/*}*/
</style>

